import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { PersonDto } from 'dtos'
import StatementOfConformitySignatureEditDialog from './StatementOfConformitySignatureEditDialog'
import { useEffect, useState } from 'react'
import { NO_FILE_UPLOADED } from 'localConstants'
import { StatementOfConformitySignatureDto, statementOfConformitySignatureInit } from 'dtos/people'
import { downloadStatementOfConformitySignatureFile, getStatementOfConformitySignature, updateStatementOfConformitySignature } from 'controllers/people/index'
import { enqueueSnackbar } from 'notistack'

interface Props {
  person: PersonDto
}

export default function StatementOfConformitySignatureCard({ person }: Props) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [isDownloading, setIsDownloading] = useState<boolean>(false)
  const [isGetting, setIsGetting] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [values, setValues] = useState<StatementOfConformitySignatureDto>(statementOfConformitySignatureInit)

  useEffect(() => {
    if (person.personGuid) {
      setIsGetting(true)
      getStatementOfConformitySignature(person.personGuid)
        .then(res => {
          setValues(res.value)
        })
        .finally(() => setIsGetting(false))
    }
  }, [person.personGuid])

  return (
    <>
      <StatementOfConformitySignatureEditDialog
        initialValues={values}
        loading={isSaving}
        onClose={() => setDialogOpen(false)}
        onSave={values => {
          setIsSaving(true)
          updateStatementOfConformitySignature(person.personGuid!, values)
            .then(res => {
              enqueueSnackbar('Statement of Conformity Signature Saved Successfully!', { variant: 'success' })
              setValues(res.value)
              setDialogOpen(false)
            })
            .finally(() => setIsSaving(false))
        }}
        open={dialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Statement of Conformity Signature
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button endIcon={<Edit />} onClick={() => setDialogOpen(true)} variant='text'>
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              {isGetting && (
                <Grid item container alignItems='center' justifyContent='center' sx={{ mt: 1 }}>
                  <Grid item>
                    <CircularProgress color='primary' size={50} />
                  </Grid>
                </Grid>
              )}

              {!isGetting && (
                <LabelField
                  label='Signature'
                  value={values.statementOfConformitySignatureFileName ? values.statementOfConformitySignatureFileName : NO_FILE_UPLOADED}
                  error={!values.statementOfConformitySignatureFileName}
                  onClick={
                    values.statementOfConformitySignatureFileName
                      ? () => {
                          setIsDownloading(true)
                          downloadStatementOfConformitySignatureFile(person.personGuid!, values.statementOfConformitySignatureFileName!).finally(() =>
                            setIsDownloading(false)
                          )
                        }
                      : undefined
                  }
                  isLoading={isDownloading}
                />
              )}
            </Grid>

            <Grid item xs={12}>
              <GreenText variant='outlined'>{``}</GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
